export default __webpack_public_path__ + "static/media/refresh.2047b82f.svg";